import React from 'react';
import Link from '@mui/material/Link';

const Header = () => {
  return (
    <header>
      <Link href="/" underline="none" color="#fff"><h1>Housing Prices Analysis</h1></Link>
    </header>
  )
}

export default Header;
